import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 550px;
`;

export const Title = styled.div`
  display: flex;
  flex-direction: column;

  span {
    margin-top: 30px;
    font-size: 18px;
    color: #515f75;
    text-align: left;
  }

  .description-container {
    margin-top: 20px;

    small {
      font-size: 15px;
    }

    input {
      width: 70px;
      height: 30px;
      padding: 0 5px;
      margin-left: 5px;
      font-weight: lighter;
      color: #858f9e;
    }
  }
`;

export const List = styled.div``;

export const TriggerDetails = styled.div`
  margin-bottom: 10px;
  margin-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #dce1e6;
`;

export const TimeTrigger = styled.div`
  margin-top: 20px;
`;

export const MessageTrigger = styled.div`
  margin-top: 20px;
`;

export const SessionRule = styled.div`
  .delete-rule-container {
    strong {
      font-size: 16px;
      color: #515f75;
    }

    img {
      cursor: pointer;
    }

    display: flex;
    justify-content: space-between;
  }

  .activators-container {
    display: flex;
    flex-direction: column;

    small {
      color: #515f75;
      font-size: 14px;

      margin-top: 15px;
    }

    .buttons {
      display: flex;
      flex-direction: row;
      margin-top: 5px;

      .button-active {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        width: 110px;
        height: 26px;
        margin-right: 6px;

        border: solid 0.7px;
        border-radius: 13px;
        background: none;
        border-color: #1384fb;

        img {
          margin-right: 5px;
        }

        > small {
          margin: 0;
          color: #1384fb;
        }
      }

      .button-disabled {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        width: 110px;
        height: 26px;
        margin-right: 6px;

        border: solid 0.7px;
        border-radius: 13px;
        background: none;
        border-color: #a8b1bf;

        color: #a8b1bf;

        opacity: 0.8;

        img {
          margin-right: 5px;
        }

        > small {
          margin: 0;
        }
      }
    }
  }
`;

export const TimeSettings = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;

  .inactivity-time-container {
    .square-selector {
    }

    small {
      color: #515f75;
      font-size: 14px;
    }

    > input {
      width: 90px;
      height: 30px;
      padding: 0 5px;
      color: #858f9e;
    }

    .select-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 5px;

      small {
        width: 120px;
        margin-bottom: 5px;
        color: #515f75;
        font-size: 14px;
        margin-right: 5px;
      }

      .css-2b097c-container {
        width: 200px;
        padding: 0;
        margin: 0;
      }

      .react-select__control {
        margin: 0;
        padding: 0 10px;
        width: 200px;
        overflow: hidden;
        font-weight: lighter;
      }
    }

    .message-container {
      display: flex;
      flex-direction: column;

      strong {
        font-size: 14px;
        color: #515f75;
      }
      textarea {
        width: 100%;
        height: 70px;
        margin-top: 5px;
        padding: 10px;
        border: 0;
        background: #f2f2f2;
        border-radius: 6px;
      }
    }

    .css-2b097c-container {
      width: 305px;
      padding: 0;
      margin: 0;
      font-weight: lighter;
    }

    .react-select__control {
      width: 305px;
      padding: 0 10px;
      overflow: hidden;
    }
  }
`;

export const MessageSettings = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5px;

  .received-message-container {
    display: flex;
    flex-direction: column;
    margin-top: 5px;

    .receive-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 5px;

      small {
        width: 90px;
        margin-bottom: 5px;
        color: #515f75;
        font-size: 14px;
      }

      .react-select__control {
        width: 390px;
        padding: 0 10px;
        font-weight: lighter;
      }

      .react-select__dropdown-indicator {
        display: none;
      }
    }

    .select-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 5px;

      small {
        width: 120px;
        margin-bottom: 5px;
        color: #515f75;
        font-size: 14px;
        margin-right: 5px;
      }

      .css-2b097c-container {
        width: 200px;
        padding: 0;
        margin: 0;
      }

      .react-select__control {
        margin: 0;
        padding: 0 10px;
        width: 200px;
        overflow: hidden;
        font-weight: lighter;
      }
    }

    .css-2b097c-container {
      width: 299px;
      padding: 0;
      margin: 0;
      font-weight: lighter;
    }

    .react-select__control {
      width: 299px;
      padding: 0 10px;
      overflow: hidden;
    }

    .message-container {
      display: flex;
      flex-direction: column;

      strong {
        font-size: 14px;
        color: #515f75;
      }
      textarea {
        width: 400px;
        height: 70px;
        margin-top: 5px;
        padding: 10px;
        border: 0;
        background: #f2f2f2;
        border-radius: 6px;
      }
    }
  }
`;

export const AddRule = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  cursor: pointer;

  small {
    font-size: 14px;
    margin-left: 5px;
    color: #1384fb;
  }
`;

export const Save = styled.div`
  margin-top: 20px;

  button {
    width: 65px;
    height: 35px;

    border: 0;
    background: #1384fb;
    border-radius: 6px;

    color: #fff;
  }
`;
